<template>
  <div class="container">
    <div class="header">
      <div class="nav">
        <ul>
          <router-link to="/home"><li class="navLi">首页</li></router-link>
          <router-link to="/about"><li>关于心动好物</li></router-link>
          <router-link to="/contact"><li>联系我们</li></router-link>
          <router-link to="/charge"><li>收费资讯</li></router-link>
          <registerModule></registerModule>
<!--          <router-link v-if="isRegister != 1" :to="{path:'/login', query:{isStatus:1}}"><el-button style="font-size:16px" type="text">注册</el-button></router-link>-->
<!--          <div v-else class="header-right">-->
<!--&lt;!&ndash;            v-if="isLogin == 1"&ndash;&gt;-->
<!--            <div class="header-user-con">-->
<!--              &lt;!&ndash;</div>&ndash;&gt;-->
<!--              &lt;!&ndash; 用户头像 &ndash;&gt;-->
<!--              <div class="user-avator">-->
<!--                <img v-if="isLogin == 2" src="../../assets/img/notLoggedIn.png">-->
<!--                <img v-else src="../../assets/img/signedIn.png">-->
<!--              </div>-->
<!--              &lt;!&ndash; 用户名下拉菜单 &ndash;&gt;-->
<!--              <router-link v-if="isLogin == 2" :to="{path:'/login', query:{isStatus:2}}"><el-button style="margin-left:10px;font-size:16px" type="text">登录</el-button></router-link>-->
<!--              <el-dropdown v-if="isLogin == 1" class="user-name" trigger="click" @command="handleCommand">-->
<!--                    <span class="el-dropdown-link">-->
<!--                      {{ userName }} <i class="el-icon-caret-bottom"></i>-->
<!--                    </span>-->
<!--                <el-dropdown-menu slot="dropdown">-->
<!--                  <el-dropdown-item command="loginout">退出登录</el-dropdown-item>-->
<!--                </el-dropdown-menu>-->
<!--              </el-dropdown>-->
<!--            </div>-->
<!--          </div>-->
        </ul>
      </div>
<!--      <div class="download">-->
<!--        <img class="logo" src="@/assets/img/LOGO.png" alt="">-->
<!--        <p class="downloadAPP">下载APP</p>-->
<!--        <div class="edition">-->
<!--          <img @mouseover="openApp(1)" @mouseout="openApp(2)" src="@/assets/img/IOS.png" alt="">-->
<!--          <img @mouseover="openAndroidApp(1)" @mouseout="openAndroidApp(2)" src="@/assets/img/Android.png" alt="">-->
<!--        </div>-->
<!--        <img ref="IOSImg" class="IOSImg" src="@/assets/img/homeDownload.jpg" alt="">-->
<!--        <img ref="AndroidImg" class="AndroidImg" src="@/assets/img/homeDownload.jpg" alt="">-->
<!--      </div>-->
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
    import bottom from '@/components/bottom.vue'
    import registerModule from "@/components/registerModule.vue";

    export default {
        name: "home",
        components:{bottom, registerModule},
        // inject:[
        //   'reload'
        // ],
        data() {
          return {
            className:'',
            // isStatus:1, //1表示注册 2表示登录
            // isLogin:localStorage.getItem('isLogin'),
            // isRegister:localStorage.getItem('isRegister'),
            // userName:localStorage.getItem('userName')
          }
        },
        methods: {
          openApp(val) {
            if(val === 1){
              this.$refs.IOSImg.style.display = 'block';
            }else if(val === 2){
              this.$refs.IOSImg.style.display = 'none';
            }
          },
          openAndroidApp(val) {
            if(val === 1){
              this.$refs.AndroidImg.style.display = 'block';
            }else if(val === 2){
              this.$refs.AndroidImg.style.display = 'none';
            }
          },
          // 用户名下拉菜单选择事件
          //退出登录
          // handleCommand(command) {
          //   if(command == 'loginout'){
          //     localStorage.setItem('isLogin', 2); //1登录 2未登录
          //
          //     console.log('显示登录状态')
          //     console.log(localStorage.getItem('isLogin'));
          //
          //     this.update();
          //     // this.$router.go(0)
          //   }
          // },
          // update(){
          //   this.reload()
          //   console.log('刷新页面')
          // }
        },
        // mounted() {
        //   console.log(localStorage.getItem('userName'));
        //   console.log(localStorage.getItem('isRegister'));
        //   console.log(localStorage.getItem('userPass'));
        // }
    }
</script>

<style scoped>
  .container{
    /*margin-left:auto;*/
    /*margin-right:auto;*/
    /*box-sizing:border-box;*/
    /*width:100%;*/
    /*position:relative;*/
  }
  .header{
    height:910px;
    background:url(../../assets/img/home1920-9100.png) no-repeat center center;
    background-size:100% 100%;
    padding-top:25px;
  }
  /*.nav{*/
  /*  height:65px;*/
  /*  margin-right:323px;*/
  /*}*/
  .nav{
    width:100%;
    height:150px;
    border: 0px solid red;
    margin:0 auto;
    background:url(../../assets/img/logoLine.png) no-repeat 230px 70px;
    background-size:268px 54px;
    padding-right:323px;
  }
  .nav ul{
    height:70px;
    display:flex;
    justify-content:flex-end;
    align-items:center;
  }
  .nav ul li{
    font-size:18px;
    font-family:'PingFang Bold';
    color:#221815;
    font-weight:600;
    padding:13px 35px;
    margin-right:20px;
  }
  .navLi{
    border:1px solid rgba(34, 24, 21, 0.5);
    border-radius:20px;
  }
  .download{
    position:absolute;
    left:379px;
    top:379px;
  }
  .logo{
    width:137px;
    height:137px;
  }
  .downloadAPP{
    font-family:'PingFang Light';
    font-size:40px;
    /*font-weight:500;*/
    color:#221815;
    margin:15px 0 25px 10px;
  }
  .edition{
    margin-left:10px;
  }
  .IOSImg{
    width:150px;
    height:150px;
    position:absolute;
    left:40px;
    bottom:-160px;
    display:none;
  }
  .AndroidImg{
    width:150px;
    height:150px;
    position:absolute;
    right:45px;
    bottom:-160px;
    display:none;
  }
  .edition img{
    width:204px;
    height:60px;
    margin-right:22px;
    cursor:pointer;
  }

  /*.header-right{*/
  /*  float: right;*/
  /*  padding-right: 50px;*/
  /*}*/
  /*.header-user-con{*/
  /*  display: flex;*/
  /*  height: 70px;*/
  /*  align-items: center;*/
  /*}*/
  /*.btn-fullscreen{*/
  /*  transform: rotate(45deg);*/
  /*  margin-right: 5px;*/
  /*  font-size: 24px;*/
  /*}*/
  /*.btn-bell, .btn-fullscreen{*/
  /*  position: relative;*/
  /*  width: 30px;*/
  /*  height: 30px;*/
  /*  text-align: center;*/
  /*  border-radius: 15px;*/
  /*  cursor: pointer;*/
  /*}*/
  /*.btn-bell-badge{*/
  /*  position: absolute;*/
  /*  right: 0;*/
  /*  top: -2px;*/
  /*  width: 8px;*/
  /*  height: 8px;*/
  /*  border-radius: 4px;*/
  /*  background: #f56c6c;*/
  /*  color: #fff;*/
  /*}*/
  /*.btn-bell .el-icon-bell{*/
  /*  color: #fff;*/
  /*}*/
  /*.user-name{*/
  /*  margin-left: 10px;*/
  /*}*/
  /*.user-avator{*/
  /*  margin-left: 20px;*/
  /*}*/
  /*.user-avator img{*/
  /*  display: block;*/
  /*  width:40px;*/
  /*  height:40px;*/
  /*  border-radius: 50%;*/
  /*}*/
  /*.el-dropdown-link{*/
  /*  color: #fff;*/
  /*  cursor: pointer;*/
  /*}*/
  /*.el-dropdown-menu__item{*/
  /*  text-align: center;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue